import React from 'react'
import { isEmpty } from 'lodash'
import Empty from './Empty'
import { useSelector } from 'react-redux'
import { translate } from 'react-i18next'

const Recent = ({ roomList, conferenceCount, keycloak, language, t }) => {
    const statusData = useSelector(state => state.conference.statusData)
    // const onMyMeeting = () => {
    //     window.open(window._env_.mymeeting)
    // }
    const renderRoomList = () => {
        if (!isEmpty(roomList)) {
            return (
                <>
                    {roomList}
                    {/* {conferenceCount > 10
                        ? <div className="view-all-pad">
                            <Button block onClick={onMyMeeting}>
                                + {t('view_all')}
                            </Button>
                        </div>
                        : null
                    } */}
                </>
            )
        } else {
            if ((!isEmpty(statusData) || statusData === "") && isEmpty(roomList))
                return <Empty status="recent" keycloak={keycloak} language={language} />
            return null
        }
    }

    return (
        renderRoomList()
    )
}

export default translate()(Recent)